import * as ActionTypes from '../actions';

// The two "auth-relevant portal fields" ECDEX-3441 moves into AuthProvider:
// a faithful extraction of exactly `portal.js`'s loggedIn/loggedOut
// transitions (see src/reducers/portal.js), nothing else. portal.js keeps
// owning everything else (reports, token, count, error, ...) -- that's
// report data, not auth identity, and stays on Redux.
//
// loggedIn here is a successful report load or the non-candidate path.
// A failed fetch leaves it false and sets portal.reportsFetched instead.
// That is a later milestone than candidateLogin.loggedIn, so this stays
// its own slice.
export const initialState = {
  loggedIn: false,
  loggedOut: false,
};

const portalAuth = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_REPORTS_REQUEST:
    case ActionTypes.FETCH_REPORTS_FAILURE:
    case ActionTypes.FETCH_REPORTS_FAILURE_INTL:
    case ActionTypes.FETCH_REPORTS_UNKNOWN_FAILURE:
    case ActionTypes.FETCH_REPORTS_BUSY:
    case ActionTypes.CLEAR_FETCH_REPORTS_FAILURE:
    case ActionTypes.FETCH_REPORTS_REDIRECT:
    case ActionTypes.PORTAL_RESET:
      return { ...initialState };
    case ActionTypes.FETCH_REPORTS_SUCCESS:
      return { ...state, loggedIn: true };
    case ActionTypes.LOGOUT_CANDIDATE:
      return { ...initialState, loggedOut: true };
    case ActionTypes.CLEAR_LOGGED_OUT:
      return { ...state, loggedOut: false };
    case ActionTypes.NON_CANDIDATE_LOGGED_IN:
      return { ...state, loggedIn: true, loggedOut: false };
    default:
      return state;
  }
};

export default portalAuth;
